/* eslint-disable */


/**
 * Create styles for `<OrderSummary />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderSummary />` styles
 */
const orderSummaryStyles = ({ theme }) => ({
  colorZambezi600: {
    color: theme.boralcolorspalette.zambezi[600],
  },
  chipCursor: {
    borderColor: theme.boralcolorspalette.zambezi[600],
    backgroundColor: `#fff`,
  },
  chipCursorClickable: {
    cursor: `pointer`,
    borderColor: theme.boralcolorspalette.zambezi[600],
    backgroundColor: `#fff`,
    '&:hover': {
      backgroundColor: `${theme.boralcolorspalette.zambezi[600]} !important`,
      color: `#fff`,
    },
    '&:hover>*': {
      color: `#fff !important`,
    },
  },
  container: {
    marginBottom: `${theme.spacing(1)}px`,
  },
  orderSummary: {
    flex: `1 1 auto`,
    order: 2,
    [theme.breakpoints.down(`xs`)]: {
      overflowX: `hidden`,
      width: `100%`,
    },
  },
  paperClasses: {
    maxHeight: `40%`,
  },
  chips: {
    flexWrap: `nowrap`,
    overflow: `auto`,
    position: `relative`,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  lastChip: {
    marginRight: theme.spacing(1) * 4,
  },
  shade: {
    position: `absolute`,
    right: 10,
    width: 50,
    bottom: 0,
    height: 66,
    backgroundImage: `linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 81%)`,
    [theme.breakpoints.up(`sm`)]: {
      display: `none`,
    },
  },
  orderTime: {
    flex: `0 0 ${theme.spacing(1) * 10}px`,
    order: 1,
    [theme.breakpoints.down(`xs`)]: {
      width: `100%`,
    },
  },
});

export default orderSummaryStyles;
